import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const Navbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={logo} alt="LoanInHand Logo" className="logo-image" />
        </Link>

        <div className="nav-hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className={`nav-center ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>Home</Link>
          <Link to="/#loans" className="nav-link" onClick={() => setIsMenuOpen(false)}>Loans</Link>
          <Link to="/#features" className="nav-link" onClick={() => setIsMenuOpen(false)}>Features</Link>
          <Link to="/#faq" className="nav-link" onClick={() => setIsMenuOpen(false)}>FAQ</Link>
        </div>

        <div className={`nav-right ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/check-status" className="nav-link status-link" onClick={() => setIsMenuOpen(false)}>
            📋 Check Status
          </Link>
          <Link to="/apply" className="apply-btn highlighted" onClick={() => setIsMenuOpen(false)}>
            🚀 Apply Loan
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;